/*
 * @Author: mycm
 * @Email: afeizt@163.com
 * @QQ: 57725649
 * @Date: 2021-11-16 09:23:15
 * @LastEditors: mycm
 * @LastEditTime: 2022-06-16
 * @Description: file content
 */


!( function ( $ ) {
	"use strict";
	;
	// $( '.weixin-logo' ).on( 'mouseover', function () {
	// 	$( '.wxqrcode' ).stop().removeClass( 'd-none' );
	// } )
	// $( '.weixin-logo' ).on( 'mouseout', function () {
	// 	$( '.wxqrcode' ).stop().addClass( 'd-none' );
	// } )
	$( ".level-1" ).on( "mouseover", function () {
		$( this ).addClass( "active" );
		$( this ).find( ".subnav" ).stop().addClass( "active" ).on( "mouseleave", function () {
			$( this ).removeClass( "active" );
			$( this ).parent().removeClass( "active" );
		} );
	} ).on( "mouseleave", function () {
		$( this ).removeClass( "active" );
		$( this ).find( ".subnav" ).removeClass( "active" );
	} );
	$( ".search-icon" ).on( "click", function () {
		$( this ).addClass( "active" );
		$( this ).parent().find( ".search-form" ).stop().addClass( "active" );
	} )
	$( ".search-form .submit" ).on( "click", function () {
		$( '#searchform' ).submit();
	} );
	$( '.search-form .cancel' ).on( 'click', function () {
		$( '.search-form' ).removeClass( "active" );
	} );
	$( ".products-area .title-tab" ).on( 'tap mousemove touchstart', function () {
		$( ".products-area .subcat" ).removeClass( 'active' )
		var tag = $( this ).data( 'target' );
		$( '#' + tag ).addClass( 'active' );
	} );
	//根据categoryid初始化分类状态
	var cid = $( "#cid" ).val();
	var categoryEl = $( '#' + cid );
	if ( cid > 0 && categoryEl.length > 0 ) {
		categoryEl.addClass( 'active' );
	}
	//quality
	$( ".quality-area .tab-item" ).on( 'tap mousemove touchstart', function () {
		$( ".artlist .tab-content" ).removeClass( 'active' )
		$( ".quality-area .tab-item" ).removeClass( 'active' )
		$( this ).addClass( 'active' );
		var tag = $( this ).data( 'target' );
		$( '#' + tag ).addClass( 'active' )
	} );
} )( jQuery );
